"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSizeType = void 0;
var InputSizeType;
(function (InputSizeType) {
    InputSizeType["LARGE"] = "l";
    InputSizeType["MEDIUM"] = "m";
})(InputSizeType = exports.InputSizeType || (exports.InputSizeType = {}));
